import NotificationTable from '../notification-table';
import {history} from '../../../../store';

const actions = [
  {
    label: 'View',
    callback: (row) => {
      history.push(`/admin/sms-logs/${row.id}`);
    },
  },
];

const SmsNotificationTable = ({ notifications, ...rest}) => (
  <NotificationTable
    title="Sms"
    actions={actions}
    notifications={notifications}
    {...rest}
  />
);

export default SmsNotificationTable;
